import styled from '@emotion/styled';

const StatusLight = styled.div<{ color: string }>(({ color }) => {
  return {
    position: 'relative',
    width: 15,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 5,
      height: 5,
      borderRadius: '50%',
      backgroundColor: color,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 5,
      height: 5,
      borderRadius: '50%',
      backgroundColor: color,
      animation: 'pulse 1.5s linear infinite',
      '@keyframes pulse': {
        '0%': {
          width: 5,
          height: 5,
          opacity: 0,
        },
        '40%': {
          width: 8,
          height: 8,
          opacity: 0.4,
        },
        '100%': {
          width: 15,
          height: 15,
          opacity: 0,
        },
      },
    },
  };
});

export default StatusLight;
